import type { FeedMessageMetadata } from '../../services/wsjFeedService';

function biasColor(bias: string): string {
  if (bias === 'Bullish') return 'text-bull-blue';
  if (bias === 'Bearish') return 'text-bear-red';
  return 'text-gray-400';
}

interface AlertCardProps {
  metadata: FeedMessageMetadata;
  comment: string;
  onTickerClick?: (symbol: string) => void;
}

export function AlertCard({ metadata, comment, onTickerClick }: AlertCardProps): React.JSX.Element {
  const m = metadata;
  return (
    <div className="bg-dark-bg rounded px-3 py-2 border border-dark-border">
      <div className="flex items-center gap-2 mb-1">
        {m.top_bet && <span className="text-accent-yellow text-xs font-bold">TOP BET</span>}
        {onTickerClick ? (
          <button
            onClick={() => onTickerClick(m.symbol!)}
            className={`font-bold ${biasColor(m.bias || '')} hover:underline cursor-pointer`}
          >
            {m.symbol}
          </button>
        ) : (
          <span className={`font-bold ${biasColor(m.bias || '')}`}>{m.symbol}</span>
        )}
        <span className={`text-xs ${biasColor(m.bias || '')}`}>{m.bias?.toUpperCase()}</span>
      </div>
      <div className="text-xs font-numeric text-white space-y-0.5">
        <div>
          ${m.strike} {m.contract_type}s
          {m.expiry && <> &middot; {m.expiry} ({m.time_to_expiry_days}d)</>}
          {m.bet_display && <> &middot; {m.bet_display}</>}
        </div>
        <div>
          {m.condition && <>{m.condition} &middot; </>}
          {m.alert_type}
          {m.multiplier && <> &middot; {m.multiplier}x Vol</>}
          {m.reference_price && <> &middot; Ref ${m.reference_price}</>}
        </div>
        {m.events && <div className="text-gray-500">{m.events}</div>}
      </div>
      {comment && (
        <p className="text-sm text-white mt-2 border-l-2 border-accent-yellow pl-2 italic">
          {comment}
        </p>
      )}
    </div>
  );
}
